var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('OrderList',{attrs:{"url-to-fetch-orders":`/api/orders/direct-debit-sales`}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }